import React from "react";

import NextImage from "../common/NextImage";
import { teamLeagueInfoUrl, titleToSlug, uniqueId } from "../../utils/generalLiveCenter";
import GolfTimeConverter from "./GolfTimeConverter";


const GolfMatch = ({ data, sport = "golf",
  websiteBaseUrl,
  dataPath,
  dataClient, }) => {
  const baseURL =
    process.env.REACT_APP_BASE_URL ??
    "https://ipublisher-microservices.6lgx.com";

  const numEntries = 4;
  const entries = data?.scores?.slice(0, numEntries);
  const placeholders = Array(numEntries - entries.length).fill("-");

  const allEntries = [...entries, ...placeholders];
  return (
    <tr>
      <td>{data?.pos || "-"}</td>
      <td>
        <div className="country_name_wrp">
          <a href={teamLeagueInfoUrl({
            dataClient,
            websiteBaseUrl,
            dataPath,
            category: "player",
            sport,
            name: titleToSlug(data?.nm),
            id: data?.id,
            tab: 'player-card'
          })}>
            <div className="flag_img">
              <NextImage
                src={`${baseURL}/assets/images/flags/country_${data?.fid}.png`}
                width={22}
                height={22}
              />
            </div>
            <span className="cr_name">{data?.nm}.</span>
          </a>
        </div>
      </td>
      <td>{data?.par || "-"}</td>
      {/* <td>{data?.thru || '-'}</td> */}
      <GolfTimeConverter timeValue={data?.teet} />
      {allEntries?.map((entry, index) => (
        <td key={uniqueId(index)}>{entry.ft || "-"}</td>
      ))}
      <td>{data?.strk}</td>

    </tr>
  );
};

export default GolfMatch;
